import React from 'react';
import _ from 'lodash';
import csvParse from 'csv-parse/lib/sync';
import { Route } from 'react-router-dom';
import HeaderThin from 'app/components/layout/HeaderThin';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';

import * as organisationsActions from 'app/ducks/organisations/actions';
import * as competitionsActions from 'app/ducks/competitions/actions';
import * as fixtureMatchesActions from 'app/ducks/fixtureMatches/actions';
import * as fixtureMatchImportsActions from 'app/ducks/fixtureMatchImports/actions';

import * as organisationSelectors from 'app/ducks/organisations/selectors';
import * as competitionSelectors from 'app/ducks/competitions/selectors';
import * as fixtureMatchSelectors from 'app/ducks/fixtureMatches/selectors';
import * as fixtureMatchImportSelectors from 'app/ducks/fixtureMatchImports/selectors';

import UploadFile from './components/UploadFile';
import MapFields from './components/MapFields';

function selector(state): any {
  return {
    organisations: organisationSelectors.getOrganisations(state),
    competitions: competitionSelectors.getCompetitions(state),
    fixtureMatches: fixtureMatchSelectors.getFixtureMatches(state),
    fixtureMatchImports: fixtureMatchImportSelectors.getFixtureMatchImports(
      state,
    ),
  };
}

const actionCreators = _.merge(
  organisationsActions,
  competitionsActions,
  fixtureMatchesActions,
  fixtureMatchImportsActions,
);

interface ICsvRunFixtureCreateProps {
  appReady: boolean;
  actions: any;
  organisations: any;
  competitions: any;
  fixtureMatches: any;
  fixtureMatchImports: any;
  match: any;
  errors: any;
}

interface ICsvRunFixtureCreateState {
  fileContent: any;
  availableFields: any;
  exampleRecord: any;
  errors: any;
}

@connect(selector, (dispatch) => ({
  actions: bindActionCreators(actionCreators, dispatch),
}))
export default class CsvRunFixtureCreate extends React.Component<
  ICsvRunFixtureCreateProps,
  ICsvRunFixtureCreateState
> {
  static defaultProps: ICsvRunFixtureCreateProps = {
    appReady: false,
    actions: undefined,
    organisations: {},
    competitions: {},
    fixtureMatches: {},
    fixtureMatchImports: {},
    match: undefined,
    errors: undefined,
  };

  state: ICsvRunFixtureCreateState = {
    fileContent: null,
    availableFields: [],
    exampleRecord: null,
    errors: {},
  };

  componentDidMount = (): void => {
    this.props.actions.getAllCompetitions();
  };

  extractHeaderColumns = (fileContent): any => {
    const records = csvParse(fileContent, {
      columns: true,
      skip_empty_lines: true,
      skip_lines_with_error: true,
    });
    const exampleRecord = records[0];
    const headerColumns = _.keys(exampleRecord);
    return [exampleRecord, headerColumns];
  };

  changeFileContent = (newContent): void => {
    const [exampleRecord, headerColumns] = this.extractHeaderColumns(
      newContent,
    );

    this.setState({
      fileContent: newContent,
      availableFields: headerColumns,
      exampleRecord,
    });
  };

  render(): React.ReactNode {
    return (
      <div>
        <div className="row">
          <div className="col">
            <HeaderThin
              divider
              breadcrumb="Connections"
              breadcrumbLink="/connections"
              title="Import Fixture CSV"
              subtitle={this.props.competitions.currentCompetition?.name}
            />
          </div>
        </div>
        <div className="row">
          <div className="col col-12 col-lg-10 col-xl-8">
            <Route
              exact
              path="/connections/:connectionId/run/csv/fixture"
              render={(): React.ReactNode => (
                <UploadFile
                  {...this.props}
                  {...this.state}
                  changeFileContent={this.changeFileContent}
                />
              )}
            />

            <Route
              exact
              path="/connections/:connectionId/run/csv/fixture/map"
              render={(): React.ReactNode => (
                <MapFields
                  {...this.props}
                  {...this.state}
                  fileContent={this.state.fileContent}
                />
              )}
            />
          </div>
        </div>
      </div>
    );
  }
}
